import { render, staticRenderFns } from "./InitialPasswordReset.vue?vue&type=template&id=03082b33&scoped=true&"
import script from "./InitialPasswordReset.vue?vue&type=script&lang=js&"
export * from "./InitialPasswordReset.vue?vue&type=script&lang=js&"
import style0 from "./InitialPasswordReset.vue?vue&type=style&index=0&id=03082b33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03082b33",
  null
  
)

export default component.exports